import FontDropdownSelect from '../../../common/FontDropdownSelect';
import { PropertyCaption } from '../../PropertyCaption';

import type { ControlRenderProps, FontControlSetting } from '../ControlTypes';

export const FontControl = ({
  control,
  modifyProperty,
  unifiedValue,
  unifiedFontWeight,
}: ControlRenderProps<FontControlSetting>) => {
  const defaultFont = typeof unifiedValue === 'string' ? unifiedValue : 'Inter';
  return (
    <>
      <PropertyCaption>{control.label}</PropertyCaption>
      <FontDropdownSelect
        action={(_p, value) =>
          modifyProperty(control.elementPaths, control.property, value)
        }
        propertyName="font_family"
        defaultValue={defaultFont}
        fontWeight={unifiedFontWeight}
        type="basic"
      />
    </>
  );
};
